import { useField } from 'formik';
import React from 'react';
import Tooltip from '../../Tooltip';
import classNames from '../../../utility/classNames';

function TextArea({ label, hint, layout, specialInstructions, ...props }) {
  const [field, meta] = useField(props);
  return (
    <div className={`sm:grid sm:grid-cols-3-inputs sm:gap-2 sm:items-start`}>
      <div className="flex gap-1 items-center justify-start">
        <label
          htmlFor={field.name}
          className="block text-md font-normal text-neutral-900"
        >
          {label}
        </label>
        {props.description && <Tooltip text={props.description} type="info" />}
      </div>
      <div className="mt-1 sm:mt-0 sm:col-span-2">
        <textarea
          {...field}
          {...props}
          rows={2}
          className={classNames(
            'block w-full border focus:border-primary bg-neutral-input focus:outline-none focus:ring-transparent  text-md rounded-md py-0 px-3 placeholder-neutral-500 placeholder-opacity-90',
            meta.touched && meta.error ? 'border-warning' : 'border-transparent'
          )}
        />
        {hint && <p className="mt-2 text-base text-primary">{hint}</p>}
        {meta.touched && meta.error ? (
          <div className="error text-base text-warning ">{meta.error}</div>
        ) : null}
      </div>
    </div>
  );
}

export default TextArea;
